/**
 * Permission utility functions.
 * Simple role-based access control for Homebase.
 */

export function isAdmin(role: string): boolean {
  return role === 'admin';
}

export function isMember(role: string): boolean {
  return role === 'member';
}
